import {Component, Renderer2, forwardRef, ViewChild, ElementRef, OnInit, EventEmitter, Output} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {faToggleOff, faToggleOn} from '@fortawesome/free-solid-svg-icons';


@Component({
    selector: 'app-slide-toggle',
    templateUrl: './slide-toggle.component.html',
    styleUrls: ['./slide-toggle.component.css'],
    standalone: false
})
export class SlideToggleComponent implements OnInit {
  faToggleOn = faToggleOn;
  faToggleOff = faToggleOff;
  toggleOn: boolean;
  @Output() refreshEvent = new EventEmitter();

  constructor() { }

  ngOnInit() {
    this.toggleOn = false;
  }

  refresh() {
    this.toggleOn = !this.toggleOn;
    this.refreshEvent.emit(this.toggleOn);
  }

}
